// extracted by mini-css-extract-plugin
export var container = "list-image-text-insides-module--container--a59bb";
export var containerText = "list-image-text-insides-module--containerText--19e62";
export var divRoot = "list-image-text-insides-module--divRoot--94def";
export var image = "list-image-text-insides-module--image--1f131";
export var root = "list-image-text-insides-module--root--9a9c5";
export var text = "list-image-text-insides-module--text--d21f5";